module.exports = {
    // basic
    'subscription': 'suscripción',
    'width': 'ancho',
    'only-show-active-rigs': 'solo mostrar plataformas activas',
    'sub-assets': 'sub bienes',
    'sort-order': 'orden de posición',
    'custom': 'personalizado',
    'direction': 'dirección',
    'sort-by': 'posición por',
    'sort': 'posición',
    'sorting': 'posicionamiento',
    'a-field-to-sort-by': 'un campo para ordenar',
    'publish': 'publicar',
    'file-type': 'tipo de archivo',
    'days-of-the-month': 'días del mes',
    'days-of-the-week': 'días de la semana',
    'days-of-report-delivery': 'días de entrega del informe',
    'time': 'hora',
    'time-of-report-delivery': 'hora de entrega del informe',
    'scheduled': 'programado',
    'delivery': 'entrega',
    'font-size': 'tamaño de fuente',
    'compressed': 'comprimido',
    'table-headers': 'encabezados',
    'rich': 'rico',
    'format': 'formato',
    'beneath': 'bajo',
    'beside': 'junto a',
    'layout': 'diseño',
    'report-format': 'formato de informe',
    'set-range': 'establecer rango',
    'date-range': 'rango',
    'recurring-range': 'rango recurrente',
    'days-on-report': 'días en el informe',
    'newest-version-only': 'solo la versión más reciente',
    'contents': 'contenido',
    'report-company': 'informe de la compañía',
    'report-type': 'tipo de informe',
    'details': 'detalles',
    'subscribe': 'suscribir',
    'unsubscribe': 'cancelar suscripción',
    'summary': 'resumen',
    'report-summary': 'resumen del informe',
    'subscribers': 'suscriptores',
    'subscribed': 'suscrito',
    'report-name': 'informe nombre',
    'report-title': 'título del informe',
    'report-file-name': 'informe nombre de archivo',
    'append-run-time-to-file-name': 'agregar tiempo de ejecución al nombre del archivo',
    'group-by': 'agrupar por',
    'time-span': 'espacio de tiempo',
    'days-previous': 'días anteriores',
    'hours-previous': 'horas anteriores',
    'wells-with-all-entry-types': 'solo pozos que contienen todos los tipos de entrada',
    'include-soft-rejected': 'Incluir rechazo suave',
    'include-link-to-entry': 'Incluir enlace a la entrada',
    'total-file-count': 'recuento total de archivo',
    'total-file-size': 'tamaño total de archivo',
    'sort': 'ordenar ',
    'run': 'Ejecutar',
    'today-only': 'Solo hoy',
    'hours-back': 'Horas atrás',
    'latest-per-rig': 'Más reciente por plataforma',
    'send-mail-when-no-data': 'enviar correo cuando no hay datos',
    // raw
    'day-required': 'Seleccione al menos un día.',
    'time-required': 'Por favor ingrese una hora.',
    'end-date-required': 'Ingrese la fecha de finalización.',
    'start-date-required': 'Ingrese la fecha de inicio.',
    'report-schedule-invalid': 'No se puede deshabilitar la programación mientras la publicación está activada.',
    'report-title-required': 'Ingrese un título de informe.',
    'report-type-required': 'Seleccione un tipo de informe.',
    'report-name-required': 'Ingrese un nombre de informe.',
    'report-well-properties-edit-help': 'Las columnas especificadas aquí se mostrarán después de las columnas predeterminadas, en el orden especificado.',
    'report-publish-on-help': 'Este informe es visible para todos los usuarios autorizados, en la página Todos los informes. Este informe estará disponible para que otros usuarios autorizados se suscriban.',
    'report-publish-off-help': 'Este informe solo es visible para usted, en la página Informes que creé. Este informe no estará disponible para que otros usuarios se suscriban.',
    'report-scheduled-on-help': 'El informe se ejecutará y se entregará a los suscriptores en el horario que se especifica a continuación.',
    'report-headers-compressed-help': 'El contenido del informe aparecerá en una sola tabla, con una sola fila de encabezado en la parte superior.',
    'report-headers-standard-help': 'El contenido del informe aparecerá en varias tablas, con una fila de encabezado en la parte superior de cada una.',
    'report-remarks-format-rich-help': 'Las observaciones conservarán todo el formato.',
    'report-remarks-format-standard-help': 'Las observaciones no incluirán ningún formato.',
    'report-remarks-layout-beneath-help': 'Las observaciones aparecerán en su propia fila, directamente debajo de todos los demás datos.',
    'report-remarks-layout-beside-help': 'Las observaciones aparecerán en la última columna, en la misma fila que todos los demás datos.',
    'report-date-range-help': 'Seleccione el rango de fechas para los datos del informe.',
    'report-subscribe-column-help': `
        Si se suscribe a un informe, lo recibirá a intervalos regulares, según su programación. Si el botón está deshabilitado, significa que el informe no tiene un horario definido.
    `,
    'report-match-all-entry-types-help': `Las entradas incluidas en el informe solo procederán de pozos que contengan al menos una entrada para todos los tipos de entrada especificados en los criterios del informe (independientemente de las entradas que se incluyan en el informe).`,
    'report-match-any-entry-types-help': `Las entradas incluidas en el informe pueden provenir de pozos que no contienen todos los tipos de entrada especificados en los criterios del informe.`,
    'report-time-span-help': `Los controles de <b>Intervalos de fechas</b> establecen el intervalo de datos incluidos en la salida.`,
    'set-range-help': `Deje <b>Fin</b> vacío para incluir todo desde <b>Inicio</b> hasta el presente (la hora en que se ejecuta el informe).`,
    'report-delete-confirm': `¿Está seguro de que desea eliminar este informe?`,
    'file-format-required': `Seleccione al menos un formato.`,
    'report-validation-failed': `Uno o más campos obligatorios faltan o son incorrectos. Revise la página y haga las correcciones donde se indique.`,
    'combined-pdf-report-rig-help': 
        `<b>Plataformas</b> controlan qué informes se incluyen en el PDF combinado, así como el orden en que aparecen. <br />
        Los informes se combinan según el orden de selección de las plataformas y luego por el nombre del pozo. <br />
        Si no se seleccionan plataformas, se incluyen todas las plataformas. `,
    'send-mail-when-no-data-no': `Si el informe está vacío, según los criterios seleccionados, no se enviará ningún correo electrónico.`,
    'send-mail-when-no-data-yes': `Si el informe está vacío, según los criterios seleccionados, se enviará un correo electrónico a todos los suscriptores.<br /> No se incluirá ningún archivo adjunto.`,
    'report-show-single': `Esta lista está actualmente filtrada para mostrar un solo informe.`,
    'report-is-empty': 'El informe está vacío',

    // template
    'report-doc-approval-well-properties-help': (words) => `
        <b>${words[0]}</b> controla qué otras columnas (que contienen metadatos sobre el pozo de esa entrada) aparecen con cada entrada.
    `,
    'report-doc-approval-well-limit-help': (words) => `
        <b>${words[0]}</b> le permite limitar las entradas a un pozo específico.
    `,
    'report-doc-approval-status-help': (words) => `
        <p>
            <b>${words[0]}</b> filtra los resultados según el estado de aprobación general de una entrada.
        </p>
        <p>
            Seleccione <b>${words[1]}</b> para filtrar aún más los resultados de las entradas pendientes de aprobación para pasos específicos.
        </p>
    `,
    'report-doc-approval-template-help': (words) => `
        <b>${words[0]}</b> le permite comenzar configurando <b>${words[1]}</b> según los criterios almacenados en una plantilla. A continuación, puede modificar los criterios del informe.
    `,
    'report-company-help': (words) => `<b>${words[0]}</b> esencialmente selecciona la empresa de los destinatarios previstos. Solo los usuarios que tengan un rol en esta empresa podrán ver y suscribirse a este informe.`,
    'well-properties-for': (words) => `Columnas para "${words[0]}"`,
    'sorting-for': (words) => `Posicionamiento for "${words[0]}"`,
    'report-file-type-help': (words) => `<b>${words[0]}</b> controla qué tipos de archivos se incluyen cuando el informe se envía a los destinatarios o cuando hace clic en <b>${words[1]}</b>.`,
    'report-scheduled-off-help': (words) => `El informe solo se ejecutará cuando se haga clic en el botón <b>${words[0]}</b> o <b>${words[1]}</b>. No se entregará a ningún suscriptor actual.`,
    'report-well-properties-help': (words) => `<b>${words[0]}</b> permite seleccionar columnas adicionales para incluir en el informe. Las columnas <b>${words[1]}</b> y <b>${words[2]}</b> se incluirán de forma predeterminada.`,
    'report-sorting-help': (words) => `<b>${words[0]}</b> controla cómo se ordena este tipo de entrada en el informe.`,
    'newest-version-only-help': (words) => `<b>${words[0]}</b> solo incluirá la entrada más reciente del tipo de entrada seleccionado para una fecha determinada.`,
    'report-tab-asset-help': (words) => `<b>${words[0]}</b> puede restringir los tipos de entrada disponibles a los disponibles en ${words[0].toLowerCase()} dentro de un activo en particular.`,
    'report-tab-well-group-help': (words) => `<b>${words[0]}</b> puede restringir los tipos de entrada disponibles a los disponibles en ${words[0].toLowerCase()} dentro de un activo en particular.`,
    'report-tab-company-help': (words) => `<b>${words[0]}</b> selecciona la empresa cuyos datos desea incluir en el informe. Todos los menús desplegables de <b>${words[1]}</b>, a continuación, se restablecen cada vez que cambia esta selección.`,
    'report-type-help': (words) => `<b>${words[0]}</b> afecta el tipo de datos que puede incluir en el informe, posiblemente también cambiando la selección de criterios en el área <b>${words[1]}</b>, debajo.`,
    'report-filename-help': (words) => `<b>${words[0]}</b> es el nombre de archivo que se utiliza cada vez que se entrega o descarga este informe.`,
    'report-title-help': (words) => `
    <b>${words[0]}</b> es el nombre que aparece en la lista de informes para otros usuarios si el informe está publicado. <br />
    En algunos casos, también aparece en la parte superior del archivo del informe cuando se genera. <br />
    Además, se puede utilizar como asunto del correo electrónico utilizado para enviar este informe si está programado.
    `,
    'report-name-help': (words) => `<b>${words[0]}</b> es el nombre que aparecerá en la lista de ${words[1]} para este informe y solo usted podrá verlo.`,
    'all-reports-company-filter': (words) => `<b>${words[0]}</b> filtra los informes solo a los informes publicados que incluyen tipos de entrada de la empresa seleccionada.`,

};
